import React from 'react';
import styled from 'styled-components';
import { formatPrice } from '@catalogo/core-helpers/price';
import Prime from '@catalogo/ui-americanas-desktop-svg/prime.svg';
import Mundo from '@catalogo/ui-americanas-desktop-svg/icon-mundo.svg';
import ArrowDown from '@catalogo/ui-americanas-desktop-svg/arrow-discount.svg';

const Stamp = ({ prime, international }) => {
  if (international) {
    return <MundoUI width="85px" height="22px" />;
  }

  if (prime) {
    return <Prime fill="#000" width="85px" height="22px" />;
  }

  return null;
};

const Price = ({ isFloating, defaultPrice, payment, prime, international }) => {
  if (!payment) {
    return (
      <>
        <Label>A partir de: </Label>
        <BestPrice>R$ {formatPrice(defaultPrice)}</BestPrice>
      </>
    );
  }

  const { listPrice, price, discount } = payment;
  const { rate } = discount;

  return (
    <>
      {!isFloating && listPrice && (
        <ListPriceWrapper>
          <ListPrice>R$ {formatPrice(listPrice)}</ListPrice>
          <Badge className="badge">
            <Arrow width="10" height="10" fill="#fff" />
            {rate >= 5 ? `${rate}%` : 'baixou'}
          </Badge>
        </ListPriceWrapper>
      )}
      <PriceWrapper>
        <BestPrice className="priceSales" isFloating={isFloating}>
          R$ {formatPrice(price)}
        </BestPrice>
        <Stamp prime={prime} international={international} />
      </PriceWrapper>
    </>
  );
};

const MundoUI = styled(Mundo)`
  margin-left: 5px;
`;

const ListPriceWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const ListPrice = styled.span`
  text-align: left;
  text-decoration: line-through;
  line-height: normal;
  margin: 0px;
  margin-right: 5px;
`;

const Badge = styled.div`
  cursor: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  align-self: flex-end;
  flex: 0 1 auto;
  background: #40cd28;
  width: auto;
  min-height: 18px;
  color: #fff;
  font-size: 12px;
  font-weight: 900;
  border-radius: 5px;
  padding: 0px 5px;
  line-height: 12px;
`;

const PriceWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const BestPrice = styled.div`
  font-size: ${props => (props.isFloating ? `25px` : `30px`)};
  line-height: 1.2;
  font-weight: 600;
  text-align: left;
  line-height: normal;
  margin: 0px;
`;

const Arrow = styled(ArrowDown)`
  margin-right: 1px;
`;

const Label = styled.label`
  font-size: 14px;
  line-height: 1.42857;
  color: #666;
`;

Price.defaultProps = {
  isFloating: false,
};

export default Price;
